import React from 'react';

export interface SwitchToggleProps {
  title: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  icon?: string;
  iconColor?: string;
  variant?: 'primary' | 'warning';
}

const SwitchToggle: React.FC<SwitchToggleProps> = ({
  title,
  description,
  checked,
  onChange,
  disabled = false,
  className = "",
  icon,
  iconColor = "tw-text-gray-500",
  variant = "primary",
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  // Define colors based on variant
  const variantColors = {
    primary: {
      enabled: "tw-bg-primary",
      focus: "focus:tw-ring-primary"
    },
    warning: {
      enabled: "tw-bg-orange-500", 
      focus: "focus:tw-ring-orange-500"
    }
  };

  const colors = variantColors[variant];

  return (
    <div className={`tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-gray-50 tw-rounded-lg tw-border tw-border-gray-200 ${className}`}>
      <div className="tw-flex tw-items-center tw-gap-3 tw-flex-1">
        {icon && (
          <span className={`material-symbols-outlined ${iconColor}`}>
            {icon}
          </span>
        )}
        <div className="tw-flex-1">
          <h4 className="tw-text-sm tw-font-medium tw-text-gray-900">
            {title}
          </h4>
          {description && (
            <p className="tw-text-xs tw-text-gray-500 tw-mt-1">
              {description}
            </p>
          )}
        </div>
      </div>
      <button
        onClick={handleToggle}
        type="button"
        disabled={disabled}
        className={`tw-relative tw-inline-flex tw-h-6 tw-w-11 tw-flex-shrink-0 tw-cursor-pointer tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors tw-duration-200 tw-ease-in-out focus:tw-outline-none focus:tw-ring-2 ${colors.focus} focus:tw-ring-offset-2 ${
          checked ? colors.enabled : "tw-bg-gray-200"
        } ${disabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""}`}
        role="switch"
        aria-checked={checked}
      >
        <span
          className={`tw-pointer-events-none tw-inline-block tw-h-5 tw-w-5 tw-rounded-full tw-bg-white tw-shadow tw-ring-0 tw-transition tw-duration-200 tw-ease-in-out ${
            checked ? "tw-translate-x-5" : "tw-translate-x-0"
          }`}
        ></span>
      </button>
    </div>
  );
};

export default SwitchToggle;